<div
  *ngIf="selectableType === type.CREATE_GROUP"
  class="container compare-footer">
  <div
    [ngClass]="{'compare-content--collapsed': sidenavCollapsed}"
    class="compare-content">

    <cui-button
      (buttonClicked)="cancel()"
      [label]="'CANCEL' | translate"
      [type]="'secondary'">
    </cui-button>

    <div *ngIf="!selections || selections?.length === 0" class="label-select">
      <span>{{'Select items and create a group' | translate}}</span>
    </div>

    <div *ngIf="selections?.length === 1" class="label-select">
      <span>{{'Select at least 2 items' | translate}}</span>
    </div>

    <div *ngIf="selections?.length > 1" class="label-selected">
      <span>{{selections?.length + ' ' + ('items selected' | translate)}}</span>
    </div>

    <cui-button
      (buttonClicked)="save()"
      *ngIf="selections?.length >= 2"
      [label]="'SAVE' | translate"
      [type]="'primary'">
    </cui-button>
  </div>
</div>

